 function tamixMakeDragable(){
    console.log("tamixMakeDragable");
    var ele = document.getElementById('tamix-scroll-drag');


    ele.style.cursor = 'grab';

    var pos = { top: 0, left: 0, x: 0, y: 0 };

    let mouseDownHandler = function (e) {
    	 console.log("mouse DownHandler");
      ele.style.cursor = 'grabbing';
      ele.style.userSelect = 'none';

      pos = {
        left: ele.scrollLeft,
        top: ele.scrollTop,
        x: e.clientX,
        y: e.clientY,
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    };

    let mouseMoveHandler = function (e) {
 	
     		 const dx = e.clientX - pos.x;
      		const dy = e.clientY - pos.y;

     		 ele.scrollTop = pos.top - dy;
     		 ele.scrollLeft = pos.left - dx;

    };

    let mouseUpHandler = function () {
    	
      ele.style.cursor = 'grab';
      ele.style.removeProperty('user-select');

      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    ele.addEventListener('mousedown', mouseDownHandler);
  }
  
  document.addEventListener("DOMContentLoaded", (event) => {
 tamixMakeDragable();
});
